import React, { useState,useContext } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import { UserContext } from '../contexts/UserContext';
import { useToast } from '../contexts/ToastContext';
import { CONFIG} from '../config';

const FeedbackWidget = ({ moduleName, onSubmit }) => {
  const [showModal, setShowModal] = useState(false);
  const [isPositive, setIsPositive] = useState(null);
  const [feedbackText, setFeedbackText] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const apiUrl = CONFIG.REACT_APP_BACKEND_URL+'/data_insertion';
  const { userId } = useContext(UserContext);
  const { showSuccess, showError } = useToast();

  const handleFeedbackClick = (positive) => {
    setIsPositive(positive);
    setFeedbackText('');
    setShowModal(true);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await axios.post(apiUrl, {
        "userQuery": moduleName,
        "feedbackStatus": isPositive ? "like":"dislike",
        "moduleName":moduleName,
        "feedbacktext": feedbackText,
        "enterprise_id": userId
      });
      showSuccess('Thank you for your valuable feedback.');
      setShowModal(false);
      setFeedbackText('');
      if (onSubmit) onSubmit()
    } catch (err) {
      console.error(err);
      showError('Something went wrong while sending feedback.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex gap-3 align-items-center mt-3" id="FeedbackWidget">
        <span className='fs-14'>Did you find this information helpful?</span>
        <span
          style={{ fontSize: '1rem', cursor: 'pointer',borderColor: '#C2A3FF', borderWidth: '2px', borderStyle: 'solid'  }}
          onClick={() => handleFeedbackClick(true)}
        >
          👍
        </span>
        <span
          style={{ fontSize: '1rem', cursor: 'pointer',borderColor: '#C2A3FF', borderWidth: '2px', borderStyle: 'solid' }}
          onClick={() => handleFeedbackClick(false)}
        >
          👎
        </span>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title className='fs-6'>{isPositive ? "Good to hear. Let us know more!" : "Let us know what went wrong. Help us impove!"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="feedbackTextArea">
              <Form.Label>Feedback </Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={feedbackText}
                onChange={(e) => setFeedbackText(e.target.value)}
                placeholder="Your feedback here..."
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowModal(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            className="btn-feedbackSubmit"
            variant="primary"
            onClick={handleSubmit}
            disabled={loading || !feedbackText.trim()}
          >
            {loading ? 'Submitting...' : 'Submit'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FeedbackWidget;
